<template>
    <div class="card">
        <h1>Iniciar Sesión</h1>
        <p>Ingrese sus datos para acceder</p>
        <form @submit.prevent="signIn">
            <vs-input
                name="email"
                data-test="input-email"
                size="large"
                v-validate="'required|email'"
                :danger="this.errors.has('email')"
                :danger-text="this.errors.first('email')"
                label-placeholder="Email"
                type="email"
                v-model="email"
                autofocus="true"
            />
            <vs-input
                name="password"
                data-test="input-password"
                size="large"
                v-validate="'required'"
                :danger="this.errors.has('password')"
                :danger-text="this.errors.first('password')"
                label-placeholder="Contraseña"
                type="password"
                v-model="password"
            />
            <div class="center">
                <button
                    class="btn btn--large"
                    data-test="button-testlogin"
                    :class="{ 'btn--loading': loading }"
                >
                    Ingresar
                </button>
                <a
                    data-test="forgot-submit-btn"
                    class="forgot-password"
                    @click="openPopup"
                >
                    ¿Olvidaste tu contraseña?
                </a>
            </div>
        </form>

        <vs-popup
            title="Recordar contraseña"
            :active.sync="rememberPaswordPopup"
            class="popup-remember-password"
        >
            <p>
                Al confirmar recibirá un correo electrónico con los pasos para
                reestablecer su contraseña. <br />
                Por razones de seguridad no almacenamos su contraseña por lo que
                nunca la enviaremos por correo.
            </p>
            <vs-input
                name="email"
                size="large"
                v-validate="'required|email'"
                :danger="this.errors.has('email')"
                :danger-text="this.errors.first('email')"
                label-placeholder="Email"
                v-model="email"
            />
            <div class="alert danger" v-if="resetPasswordError">
                <vs-icon icon="error"></vs-icon>
                {{ this.resetPasswordError }}
            </div>
            <vs-button
                data-test="resetpassword-submit-btn"
                @click="resetPasswordEmail"
                :class="{ loading: loadingReset }"
                color="success"
                type="filled"
                >Reiniciar contraseña</vs-button
            >
        </vs-popup>
    </div>
</template>

<script>
import gql from "graphql-tag";
import axios from "axios";
import { print } from "graphql";
const generateResetToken = gql`
    mutation generateResetToken($email: String!) {
        generateResetToken(email: $email) {
            message
            success
            code
        }
    }
`;

const fetchOnboardingStep = gql`
    query fetchOnboardingStep($currentUserToken: String!, $steps: [String!]!) {
        fetchOnboardingStep(
            currentUserToken: $currentUserToken
            steps: $steps
        ) {
            name
            seen
        }
    }
`;

export default {
    name: "LoginForm",
    data: function () {
        return {
            email: "",
            password: "",
            rememberPaswordPopup: false,
            loading: false,
            loadingReset: false,
            resetTokenSent: false,
            resetPasswordError: "",
            remainingSteps: 0,
            hideTutorial: Boolean,
        };
    },
    mounted() {
        localStorage.removeItem('USER_TOKEN');
    },
    methods: {
        signIn() {
            this.$validator.validate().then((res) => {
                if (res) {
                    this.loading = true;

                    this.$store
                        .dispatch("User/signIn", {
                            email: this.email,
                            password: this.password,
                        })
                        .then((auth) => {
                            this.fetchSteps(auth.admin);
                        })
                        .catch((err) => {
                            this.loading = false;
                            this.$vs.notify({
                                title: "Error al iniciar sesión",
                                time: 8000,
                                text: err[0].message,
                                color: "#eb4d4b",
                                position: "top-center",
                                icon: "error",
                            });
                        });
                }
            });
        },

        resetPasswordEmail() {
            this.loadingReset = true;
            this.resetPasswordError = "";
            axios
                .post(`${process.env.VUE_APP_GRAPH_PATH}`, {
                    query: print(generateResetToken),
                    variables: {
                        email: this.email,
                    },
                })
                .then((res) => {
                    if (!res.data.errors) {
                        if (res.data.data.generateResetToken.success) {
                            this.rememberPaswordPopup = false;
                            this.$vs.notify({
                                title: "Recuperar contraseña",
                                time: 8000,
                                text: "Email enviado con éxito",
                                color: "#50b83d",
                                position: "top-center",
                                icon: "check_circle",
                            });
                        } else {
                            this.resetPasswordError = this.$t(
                                `graph.${res.data.data.generateResetToken.code}`
                            );
                        }
                    } else {
                        console.log(res.data.errors);
                    }
                    this.loadingReset = false;
                });
        },

        fetchSteps(admin) {
            if (admin) {
                this.$router.push("/admin");
                return;
            }

            axios
                .get(`${process.env.VUE_APP_GRAPH_PATH}`, {
                    params: {
                        query: print(fetchOnboardingStep),
                        variables: {
                            currentUserToken: localStorage.getItem(
                                "USER_TOKEN"
                            ),
                            steps: [
                                "account",
                                "entity",
                                "market",
                                "offer",
                                "hideTutorial",
                            ],
                        },
                    },
                })
                .then((res) => {
                    if (!res.data.errors) {
                        this.remainingSteps = res.data.data.fetchOnboardingStep.filter(
                            (el) =>
                                el.seen === false && el.name != "hideTutorial"
                        ).length;
                        this.hideTutorial =
                            res.data.data.fetchOnboardingStep[4].seen;
                        if (this.remainingSteps && this.hideTutorial == false) {
                            this.$router.push("/first-steps");
                        } else {
                            this.$router.push("/");
                        }
                    } else {
                        console.log(res.data.errors);
                    }
                });
        },

        openPopup() {
            this.rememberPaswordPopup = true;
        },
    },
};
</script>

<style lang="css" scoped>
.register {
    margin-top: 2em;
    color: grey;
    font-size: 0.8rem;
}

.card {
    text-align: center;
}

form {
    text-align: initial;
}
</style>
